<template>
  <div>
    <b-row class="bg-white">
      <b-col
        cols="12"
        lg="3"
        md="6"
        class="text-dark mb-5 align-self-stretch"
        v-for="(establecimiento, index) in arregloEstablecimientos"
        :key="establecimiento.rbd + '-' + index"
      >
        <div class="bg-white hovereffect">
          <!-- Nombre -->
          <router-link
            :to="'/establecimiento/' + establecimiento.rbd"
            class="text-azul"
          >
            <div
              class="d-flex bg-white gilmer h5 mb-1 overflow-hidden"
              v-b-tooltip.hover
              :title="establecimiento.nombre.toUpperCase()"
            >
              <span
                class="titulo-ficha mx-auto text-center align-self-center text-morado-claro"
              >
                {{ establecimiento.nombre.toUpperCase() }}
              </span>
            </div>
            <!-- Imagen -->
            <div class="bg-azul-oscuro">
              <Imagen
                :imagen="imagenPrincipal(establecimiento)"
                :rbd="establecimiento.rbd"
                :alt="'imagen-principal'"
                :width="512"
                :height="384"
                imgClass="img-fluid d-none d-lg-block"
              />
            </div>
            <div class="overlay d-none d-xl-block">
              <router-link
                :to="'/establecimiento/' + establecimiento.rbd"
                class="btn btn-yellow border border-light text-uppercase text-morado-claro font-weight-bold stretched-link"
                >Ver establecimiento</router-link
              >
            </div>
          </router-link>
          <div class="border">
            <!-- Simbologia -->
            <Simbologia
              :rbd="establecimiento.rbd"
              class="w-100 mx-0 border-bottom mb-1 pb-2 pt-2 justify-content-center"
              posicionTooltip="bottom"
              :mostrarCopago="true"
              :esGratuito="esGratuito(establecimiento)"
              :genero="regimenGenero(establecimiento)"
              :subvencionPreferencial="esSep(establecimiento)"
              :integracionEscolar="esPie(establecimiento)"
            />
            <!-- Detalles Mini Ficha -->
            <router-link :to="'/establecimiento/' + establecimiento.rbd">
              <b-row class="py-2 px-3">
                <b-col cols="2" class="my-1 px-2 text-right"
                  ><FontAwesomeIcon
                    icon="map-marker-alt"
                    class="text-gris-light my-auto"
                /></b-col>
                <b-col
                  cols="10"
                  class="py-1 px-1 text-left direccion text-morado-claro"
                  >{{ establecimiento.sedes[0].direccion.calle }}</b-col
                >
                <b-col cols="2" class="my-1 px-2 text-right"
                  ><FontAwesomeIcon
                    icon="university"
                    class="text-gris-light my-auto"
                /></b-col>
                <b-col
                  cols="10"
                  class="py-1 px-1 text-left text-morado-claro"
                  >{{ textoDependencia(establecimiento) }}</b-col
                >
                <b-col cols="2" class="my-1 px-2 text-right"
                  ><FontAwesomeIcon
                    icon="chalkboard-teacher"
                    class="text-gris-light my-auto"
                /></b-col>
                <b-col
                  cols="10"
                  class="py-1 px-1 text-left text-morado-claro"
                  >{{ rangoNivel(establecimiento) }}</b-col
                >
                <b-col cols="2" class="my-1 px-2 text-right"
                  ><FontAwesomeIcon
                    icon="user-friends"
                    class="text-gris-light my-auto"
                /></b-col>
                <b-col cols="10" class="py-1 px-1 text-left text-morado-claro"
                  >{{
                    establecimiento.informacionInstitucional.alumnosMatriculados
                  }}
                  matriculados</b-col
                >
                <b-col cols="2" class="my-1 px-2 text-right"
                  ><FontAwesomeIcon
                    icon="id-card-alt"
                    class="text-gris-light my-auto"
                /></b-col>
                <b-col cols="10" class="py-1 px-1 text-left text-morado-claro"
                  >{{
                    establecimiento.informacionInstitucional
                      .promedioAlumnosPorCurso
                  }}
                  alumnos por curso</b-col
                >
              </b-row>
            </router-link>
          </div>
        </div>
        <router-link
          :to="'/establecimiento/' + establecimiento.rbd"
          :id="'ver-establecimiento-' + index"
          :data-testid="'ver-establecimiento-' + index"
          class="btn btn-azul-oscuro text-white w-100 mt-2 mb-1 font-weight-bold text-uppercase d-inline-block d-xl-none"
          >Ver establecimiento</router-link
        >
      </b-col>
    </b-row>
    <b-pagination
      v-show="establecimientos.length > 0"
      v-model="pagina"
      :per-page="datosPorPagina"
      :total-rows="establecimientos.length"
      align="center"
    >
      <span slot="page" slot-scope="{ page, active }">
        <b v-if="active">{{ page }}</b>
        <i v-else>{{ page }}</i>
      </span>
    </b-pagination>
  </div>
</template>

<script>
import Imagen from "@/components/generales/Imagen";
import Simbologia from "@/components/generales/Simbologia";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faMapMarkerAlt,
  faUniversity,
  faChalkboardTeacher,
  faUserFriends,
  faIdCardAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(
  faMapMarkerAlt,
  faUniversity,
  faChalkboardTeacher,
  faUserFriends,
  faIdCardAlt
);
export default {
  props: {
    establecimientos: {
      type: Array,
      required: true
    }
  },
  components: {
    FontAwesomeIcon,
    Imagen,
    Simbologia
  },
  data() {
    return {
      pagina: 1,
      arregloEstablecimientos: [],
      datosPorPagina: 8
    };
  },
  watch: {
    pagina() {
      this.$gtag.event("ver-pagina", {
        event_category: "paginado",
        event_label: "ver-pagina" + this.pagina,
        value: ""
      });
      this.paginaEstablecimientos(this.establecimientos, this.pagina);
    },
    establecimientos() {
      this.paginaEstablecimientos(this.establecimientos, this.pagina);
    }
  },
  methods: {
    //calcula la pagina nueva del
    paginaEstablecimientos: function(establecimientos, pagina) {
      let arreglo = [];
      if (establecimientos.length > 0) {
        let inicio = (pagina - 1) * this.datosPorPagina;
        let final =
          pagina * this.datosPorPagina > establecimientos.length
            ? establecimientos.length
            : pagina * this.datosPorPagina;
        arreglo = establecimientos.slice(inicio, final);
      }
      this.arregloEstablecimientos = arreglo;
    },
    //calcula el texto de rango nivel para un establecimiento
    rangoNivel: function(establecimiento) {
      return establecimiento.nivelMinimo + " - " + establecimiento.nivelMaximo;
    },
    //checkea genero de un establecimiento
    regimenGenero: function(establecimiento) {
      return establecimiento.informacionInstitucional.regimen;
    },
    //checkea gratuidad de un establecimiento
    esGratuito: function(establecimiento) {
      if (establecimiento.etiquetas !== undefined) {
        return establecimiento.etiquetas.includes("GRATUITO");
      } else {
        return false;
      }
    },
    //checkea estatus PIE de un establecimiento
    esPie: function(establecimiento) {
      if (establecimiento.etiquetas !== undefined) {
        return establecimiento.etiquetas.includes("PIE");
      } else {
        return false;
      }
    },
    //checkea SEP de un establecimiento
    esSep: function(establecimiento) {
      if (establecimiento.etiquetas !== undefined) {
        return establecimiento.etiquetas.includes("SEP");
      } else {
        return false;
      }
    },
    //calcula texto dependencia
    textoDependencia: function(establecimiento) {
      switch (establecimiento.dependencia) {
        case "PARTICULAR SUBVENCIONADO":
          return "Particular subvencionado";
        default:
          return "Público";
      }
    },
    //obtiene imagen principal del establecimiento
    imagenPrincipal: function(establecimiento) {
      if (establecimiento.imagenes && establecimiento.imagenes.length > 0) {
        let ext = establecimiento.imagenes[0].nombre.slice(
          ((establecimiento.imagenes[0].nombre.lastIndexOf(".") - 1) >>> 0) + 2
        );
        return `miniatura.${ext}`;
      }
      return "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/busqueda/establecimientos/DetalleEstablecimientos.vue